import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import "react-toastify/dist/ReactToastify.css";
import "./KycResult.css";
import Geocode from "react-geocode";

const KycResult = () => {
  let location = useLocation();
  let history = useHistory();
  
  const [loading, setLoading] = useState(false);
  const [atlasKycCheckId, setAtlasKycCheckId] = useState(null);
  const [capchaVideoFile, setCapchaVideoFile] = useState(null);
  const [message, setMessage] = useState('KYC Verification in Progress... this will just take a moment.');
  const [countdown, setCountdown] = useState(3);
  const [apiCompleted, setApiCompleted] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("");

    const getCurrentLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            Geocode.setApiKey(process.env.REACT_APP_GOOGLE_LOCATION_API_KEY);
            Geocode.setLanguage("en");
            Geocode.setRegion("in");
            Geocode.setLocationType("ROOFTOP");
            Geocode.enableDebug();
            Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
              (response) => {
                const fullAddress = response.results[0].formatted_address;
                setCurrentLocation(fullAddress);
              },
              (error) => {
                console.error(error);
                toast.error("Failed to get location. Please try again.", {
                  position: "top-right",
                  autoClose: 3000,
                });
              }
            );
          },
          (e) => {
            console.error("Geolocation error:", e);
            toast.error("Location access denied. Please enter location manually.", {
              position: "top-right",
              autoClose: 3000,
            });
          },
          {
            enableHighAccuracy: true
          }
        );
      } else {
        toast.error("Geolocation is not supported by your browser.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    };

  useEffect(() => {
    window.scrollTo(0, 0);
     getCurrentLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const checkId = urlParams.get('atlasKycCheckId');
    if (checkId) {
      setAtlasKycCheckId(checkId);
    }
    
    // if (location.state && location.state.kycData) {
    //   if (location.state.kycData.capchaVideoFile) {
    //     setCapchaVideoFile(location.state.kycData.capchaVideoFile);
    //   }
    // } else if (location.state && location.state.userInfo) {
    //   const userInfo = location.state.userInfo;
    //   if (Array.isArray(userInfo) && userInfo[0] instanceof Blob) {
    //     setCapchaVideoFile(userInfo[0]);
    //   }
    // } else {
    //   const storedData = localStorage.getItem('kycVerificationData');
    //   if (storedData) {
    //     try {
    //         const parsedData = JSON.parse(storedData);

    //         if (parsedData && parsedData.type === 'base64' && parsedData.data) {
    //           fetch(parsedData.data)
    //             .then(response => {
    //               if (!response.ok) {
    //                 throw new Error('Failed to fetch blob from data URL');
    //               }
    //               return response.blob();
    //             })
    //             .then(blob => {
    //               setCapchaVideoFile(blob);
    //             })
    //             .catch(error => {
    //               console.error('Error converting base64 to blob:', error);
    //               localStorage.removeItem('kycVerificationData');
    //             });
    //         }
    //     } catch (error) {
    //       console.error('Error parsing stored KYC data from localStorage:', error);
    //       localStorage.removeItem('kycVerificationData');
    //     }
    //   }
    // }
  }, [location]);

  useEffect(() => {
    if (atlasKycCheckId) {
      fetchAadhaarDetailsData(atlasKycCheckId);
    }
  }, [atlasKycCheckId]);

  useEffect(() => {
    if (!apiCompleted) {
      const countdownInterval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            history.push("/profile");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, [apiCompleted]);



  const fetchAadhaarDetailsData = (checkId) => {
    setLoading(true);
    
    const form = new FormData();
    form.append('check_id', checkId);
    form.append("kyc_current_location", currentLocation || '')
    
    // if (capchaVideoFile instanceof File || capchaVideoFile instanceof Blob) {
    //   form.append('file', capchaVideoFile, 'video.mp4');
    // }
    
    profileUpdateService
      .fetchAadhaarDetails(form)
      .then((response) => {
        setApiCompleted(true);
        if(response.status == 200){
        setMessage("KYC Verification successful! Redirecting...");
        toast.success('Aadhaar details fetched successfully', {
          position: "top-right",
          autoClose: 3000,
        });
      }
        
        setTimeout(() => {
          history.push("/profile");
        }, 1000);
      })
      .catch((error) => {
        console.error('Error fetching Aadhaar details:', error);
        setApiCompleted(true);
        setMessage("KYC Verification failed. Redirecting...");
        toast.error('Failed to fetch Aadhaar details. Please try again.', {
          position: "top-right",
          autoClose: 5000,
        });
        
        setTimeout(() => {
          history.push("/profile");
        }, 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  };



  return (
    <div className="kyc-verification-container">
      <div className="kyc-auth-card">
        <div className="kyc-status-icon">
          <img src="/assets/images/KycWaitingIcon.svg" alt="KYC Verification" />
        </div>
        
        <h2 className="kyc-auth-title">
          KYC Verification in Progress
        </h2>
        
        <p className="kyc-auth-subtitle">
          We've received your KYC details and they're now under review.
        </p>
        
        <div className="kyc-info-section">
          <h4>What's Happening?</h4>
          <ul>
            <li>Our team has been notified</li>
            <li>Your documents will be reviewed and verified.</li>
            <li>Once approved, your profile will be marked as Verified.</li>
            <li>You'll receive an email notification when the process is complete.</li>
          </ul>
        </div>
        
        <p className="kyc-countdown-text">
           Redirecting to Profile in {countdown} Seconds...
        </p>
        
      </div>
      {loading && (
        <div className="kyc-loading-overlay">
          <div className="kyc-loading-spinner"></div>
        </div>
      )}
      <Loader loading={loading} />
      <ToastContainer />
    </div>
  );
};

export default KycResult;
